module.exports = __webpack_public_path__ + "static/guide.d0cdf892.png";